// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1L2da","footer":"ModalFilter_footer__3fCv0"};